import {
  Avatar, Button, Col, Row, Space, Typography
} from "antd";
import { UserOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useCurrentUser from "../../hooks/useCurrentUser";
import { appRoutes } from "../../constants/routes";

const {
  Text,
  Title
} = Typography;

const DoctorData = () => {
  const { t } = useTranslation();
  const { data } = useCurrentUser();

  return (
    <Space size="middle" style={{ marginBottom: "10vh", width: "100%" }}>
      <Avatar size={96} icon={<UserOutlined />} src={data.photo} />
      <Space direction="vertical" style={{ width: "100%" }}>
        <Title level={2} style={{ marginBottom: 0 }}>
          {t("global.labels.welcome")}, {t("global.labels.doctorPrefix")} {data.name} {data.surname}
        </Title>
        <span>n. polizza {data.policy_number}</span>
        <Row gutter={[16, 16]}>
          <Col xs={24} md={10}>
            <Text type="secondary">{t("dashboardPage.appointments.info")}</Text>
          </Col>
          <Col xs={24} md={14}>
            <Link to={appRoutes.appointments}>
              <Button type="primary" size="large">{t("dashboardPage.appointments.button")}</Button>
            </Link>
          </Col>
        </Row>
      </Space>
    </Space>
  );
};

export default DoctorData;
